<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header" class="p-2">
        {{ this.$route.meta.title }}
        <div class="card-header-actions"></div>
      </div>
      <b-input-group>
        <b-input-group-prepend><label class="ml-2">Current Date (Sistem)</label></b-input-group-prepend>
        <b-form-input id="input-1" v-model="model.currentdate" type="date" :min="model.currentdate"
          :max="model.currentdate" disabled></b-form-input>
        <b-input-group-prepend><label class="ml-2">Next Date</label></b-input-group-prepend>
        <b-form-input id="input-1" v-model="model.nextdate" type="date" disabled class="mr-3"></b-form-input>
        <b-button type="submit" variant="primary" @click="showConfirm = true">Close Current Date (Sistem)</b-button>
      </b-input-group>
    </b-card>
    <b-modal v-model="showConfirm" title="Clossing" :centered="true" @ok="closeeod">
      <p class="mb-1">You will Clossing?</p>
    </b-modal>
  </div>
</template>

<script>
import toastr from "mini-toastr";
toastr.init();
import moment from "moment";
import pinjaman from "../../apis/pinjamankredit";

export default {
  data() {
    return {
      showConfirm: false,
      model: {
        currentdate: "",
        nextdate: "",
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    timeServer() {
      if (this.$store.state) {
        return this.$store.state.timeServer;
      } else {
        return "";
      }
    },
  },
  created: async function () {
    if (this.user.compcode) {
      const timeServer = this.$store.state.timeServer[this.user.compcode];
      this.model.currentdate = moment(timeServer).format("YYYY-MM-DD");
      this.model.nextdate = moment(timeServer)
          .add(1, "days")
          .format("YYYY-MM-DD");
    }
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    timeserver(value) {
      let user = this.$store.state.user;
      if (value.compcode == user.compcode) {
        const timeServer = value.timeServer;
        this.model.currentdate = timeServer;
        this.model.nextdate = moment(timeServer)
          .add(1, "days")
          .format("YYYY-MM-DD");
      }
    }
  },
  methods: {
    async closeeod(event) {
      try {
        await pinjaman.closeeod(this.model);
        router.push({ name: "loan.home" });
      } catch (error) {
        toastr.error(JSON.stringify(error), "Save Receipt Error");
      }
    },
  },
};
</script>